"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  STANDARD: 'direction-standard',
  REVERSE: 'direction-reverse'
};
exports.default = _default;